export class EMAIL {
  public static EMAIL_TYPE_ACCOUNT_INFORMATION = '01';
  public static EMAIL_TYPE_RESET_PASSWORD = '02';
  public static EMAIL_TYPE_EMAIL_CHANGE_REQUEST = '51';
}
